<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">


            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

            <div class="card shadow m-3" style="width: 100%">

                <div class="card-body">

                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-md-2">
                                <!-- <img src="#" alt="Flag" width="100" height="100" class="border" > -->
                                <img src="https://via.placeholder.com/100" alt="Logo" class="border rounded-0">
                            </div>
                            <div class="col-md-8 text-center">
                                <h3 class="text-dark font-weight-bold">MEDBURY MEDICAL SERVICES</h3>
                                <h5 class="text-danger font-weight-normal">A MEMBER OF THE LAGOS COVID-19 LABORATORY
                                    CONSORTIUM LAGOS STATE
                                </h5>
                                <h3 class="text-info font-weight-bold">LABORATORY INVESTIGATION RESULT PAGE</h3>
                            </div>
                            <div class="col-md-2">
                                <!-- <img src="#" alt="Logo" width="100" height="100" class="border" > -->
                                <img src="https://via.placeholder.com/100" alt="Logo" class="border rounded-0">
                                <p class="font-weight-bold">No 63028175</p>
                            </div>

                            <div class="col-md-12">
                                <span class="ml-5">To verify the authenticity of this test result, visit <a
                                        href="https://covid19.medfit.com.ng/verify-result">https://covid19.medfit.com.ng/verify-result</a></span>
                            </div>

                        </div>

                        <div class="row justify-content-center mt-5">
                            <div class="col-md-12 text-center">
                                <h4 class="font-weight-bold">
                                    <u>VIROLOGICAL SCREENING TEST FOR COVID-19
                                        OUTBREAK</u>
                                </h4>
                            </div>
                        </div>

                        <div class="row  mt-4">
                            <span><strong>Date: </strong><u>12/02/2021</u></span>
                        </div>

                        <div class="container mt-3 bg-light">

                            <div class="row">
                                <div class="col-md-5">
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">NAME: </span> Amaka Jones</span>
                                    </p>
                                    <p class="text-dark">
                                        <span class="mr-5"><span class="font-weight-bold">AGE: </span> 32 </span>
                                        
                                    </p>
                                    <p class="text-dark">
                                    
                                        <span><span class="font-weight-bold">SEX: </span> Male </span>
                                    </p>
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">ADDRESS: </span> 17, Dummy Street,
                                            Malobo.</span>
                                    </p>
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">PHONE NO: </span> 08163848488</span>
                                    </p>
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">EMAIL: </span> amaka@gmail.com</span>
                                    </p>
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">NATIONALITY: </span> Nigerian</span>
                                    </p>
                                </div>
                                <div class="col-md-2">
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">SAMPLE COLLECTED: </span>
                                            <br />
                                            11/02/2021
                                        </span>
                                    </p>
                                </div>
                                <div class="col-md-5">
                                    <p class="text-dark">
                                        <span><span class="font-weight-bold">SAMPLE(S): <br />
                                                SCREENING/REPEAT/FOLLOW
                                            </span>
                                        </span>
                                    </p>

                                    <!-- Table -->
                                    <table class="table table-bordered table-light">
                                        <tbody>
                                            <tr>
                                                <th scope="row">1.</th>
                                                <th scope="row">NASOPHARYNGEAL</th>
                                                <th scope="row">X</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">2.</th>
                                                <th scope="row">OROPHARYNGEAL</th>
                                                <th scope="row">X</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">3.</th>
                                                <th scope="row">SPUTUM</th>
                                                <th scope="row">-</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">4.</th>
                                                <th scope="row">VENOUS BLOOD</th>
                                                <th scope="row">-</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">5.</th>
                                                <th scope="row">OTHERS</th>
                                                <th scope="row">-</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Table End -->

                                    <p class="mt-4 mb-3 text-dark">
                                        <span class="font-weight-bold">DATE OF RESULT: </span> 12/02/2021
                                    </p>

                                    <!-- Table -->
                                    <table class="table table-light">
                                        <tbody>
                                            <tr>
                                                <th scope="row">POSITIVE</th>
                                                <th scope="row">X</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">NEGATIVE</th>
                                                <th scope="row">-</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Table End -->
                                </div>
                            </div>

                        </div>


                        <!-- Result -->
                        <div class="row  mt-5">
                            <span><span class="font-weight-bold">RESULT: </span></span>
                        </div>

                        <div class="container">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">S/N</th>
                                        <th scope="col">TEST DONE</th>
                                        <th scope="col">LAB CODE (SPECIMEN USED)</th>
                                        <th scope="col">REFERENCE RANGE</th>
                                        <th scope="col">TEST VALUE</th>
                                        <th scope="col">COMMENT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>RT-PCR FOR SARS-COV2</td>
                                        <td>LEK3635</td>
                                        <td>ABOVE CUTT OFF</td>
                                        <td></td>
                                        <td>NEGATIVE</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <!-- End Result -->

                        <!-- Comment -->
                        <div class="row mt-5">
                            <div class="col-md-12 text-dark">
                                <div class="border" style="border-radius: 20%; padding: 2%;">
                                    <p><span class="font-weight-bold"><u>General Comment</u></span></p>
                                    <p><span class="font-weight-bold">NEGATIVE FOR SARS COV 2 (COVID-19) AS AT: </span>
                                        <u>11/02/2021</u>
                                    </p>
                                </div>
                                <div>
                                    <p><span class="font-weight-bold">Signature: </span></p>
                                    <p>............................</p>

                                    <p><span class="font-weight-bold">Name: </span> Dr Michael Dada</p>

                                    <p><span class="font-weight-bold">Designation: </span> Laboratory Manager</p>
                                </div>

                            </div>
                        </div>
                        <!-- Comment  - End -->

                        <!-- Contact Info box -->
                        <div class="row mt-5 mb-5">
                            <div class="col-md-12 bg-danger text-center p-3">

                                <p class="text-white"><span class="font-weight-bold">Lagos: </span> Plot 1-4 Admiralty
                                    Way, (Opposite
                                    Freshforte and Beside Devine Mercy Church), Lekki Phase 1, Lagos, Nigeria</p>
                                <p class="text-white"><span class="font-weight-bold">Lagos: </span> 30b, Aba Johnson
                                    Crecent, Adeniyi
                                    Jones, Ikeja, Lagos, Nigeria</p>
                                <p class="text-white"><span class="font-weight-bold">PH: </span> 45, Eleinwo Street, GRA
                                    Phase 1, Port
                                    Harcourt, Rivers, Nigeria</p>

                                <p></p>

                                <p class="text-white"><span class="font-weight-bold">Phone: </span>080373733838
                                    <span class="font-weight-bold  ml-3">Email:
                                    </span>covid19testing@medburymedicals.com.ng
                                    <span class="font-weight-bold  ml-3">Twitter: </span>@MedBuryNG
                                    <span class="font-weight-bold  ml-3">Instagram: </span>@medburyng
                                </p>

                            </div>
                        </div>
                        <!-- Contact Info box -->



                    </div>

                </div>

            </div>
        </div>

    </div>
</div>

<app-footer-dashboard></app-footer-dashboard>